<script lang="ts">
  let {
    src,
    size = 'default',
    label,
    class: klass = '',
  }: {
    src: string
    size?: 'default' | 'medium' | 'large'
    label?: string
    class?: string
  } = $props()
</script>

<span
  class="icon {klass}"
  class:medium={size === 'medium'}
  class:large={size === 'large'}
  style={`--icon-url: url("${src}")`}
  role={label ? 'img' : undefined}
  aria-label={label}
  aria-hidden={label ? undefined : 'true'}
></span>

<style>
  .icon {
    --size: var(--icon-size, 1em);
    display: inline-block;
    width: var(--size);
    height: var(--size);
    flex-shrink: 0;
    background-color: var(--icon-color, currentColor);
    mask: var(--icon-url) center / contain no-repeat;
    -webkit-mask: var(--icon-url) center / contain no-repeat;
  }

  .medium {
    --size: 1.3em;
  }

  .large {
    --size: 1.55em;
  }
</style>
